var map = {
	"./be/translation.json": 927,
	"./cs/translation.json": 928,
	"./de/translation.json": 929,
	"./en/translation.json": 930,
	"./fr/translation.json": 931,
	"./hy/translation.json": 932,
	"./ka/translation.json": 933,
	"./kk/translation.json": 934,
	"./ru/translation.json": 935,
	"./tg/translation.json": 936,
	"./tr/translation.json": 937,
	"./zh/translation.json": 938
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1815;